import { SignalRTypes, SlotsActionTypes } from "../actions";
import { SessionStorage } from "../../helpers";

const initState = {
  loading: false,
  jackpotBalances: null,
  // jackpotData: null,
  error: null,
  winningMessage: null,
  currentWin: SessionStorage.currentWin,
  jackpotWinningApproved: SessionStorage.jackpotWinningApproved
};

const jackpot = (state = initState, action) => {
  switch (action.type) {
    case SlotsActionTypes.Get_Jackpot_Request:
      return {
        ...state,
        loading: true,
        jackpotBalances: null,
        winningMessage: null,
        jackpotId: null
      };
    case SlotsActionTypes.Get_Jackpot_Success:
      return {
        ...state,
        loading: false,
        jackpotBalances: action.jackpotBalances,
        winningMessage: action.winningMessage,
        jackpotId: action.jackpotId,
        winnerJackpotId: action.winnerJackpotId,
        singleGameWinningMessage: action.singleGameWinningMessage,
        singleGameJackpotId:action.singleGameJackpotId,
        singleGameWinnerJackpotId: action.singleGameWinnerJackpotId
      };
    case SlotsActionTypes.Get_Jackpot_Error:
      return {
        ...state,
        loading: false,
        error: action.message,
        winningMessage: null,
        jackpotId: null
        //  jackpotData: null
      };
    case SlotsActionTypes.Jackpot_Winning_Success:
      return {
        ...state,
        loading: false,
        //jackpotBalances: action.jackpotBalances,
        // winningMessage: [...state.winningMessage, action.winningMessage],
         winningMessage:  action.winningMessage,
         singleGameWinningMessage:  action.singleGameWinningMessage,
         winnerJackpotId: action.winnerJackpotId,
      };
    case SignalRTypes.Jackpot_Balance_Success:
      return {
        ...state,
        loadingBalances: false,
        jackpotBalances: action.jackpotBalances,

      };
      case SignalRTypes.Jackpot_Approval_Update_Request:
        return {
          ...state,
          winnerJackpotId: null,
          jackpotId: null,
          winningMessage: null
  
        };
    // case SignalRTypes.Set_Jackpot_Won_Message:
    //   return {
    //     ...state,
    //     winningMessage: action.messages
    //   };
    // case SignalRTypes.Jackpot_Winning_Approved:
    //   return {
    //     ...state,
    //     jackpotWinningApproved: action.jackpotWinningApproved
    //   }
    // case SignalRTypes.Set_Is_Jackpot_Won:
    //   return {
    //     ...state,
    //     currentWin: action.currentWin
    //   };
    default:
      return state;
  }
};
export default jackpot;
